import React from "react";
import "../nav/Navigation.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCamera} from "@fortawesome/free-solid-svg-icons";

function CameraTag() {

    return (
        <>
            <div className={`user-tag d-inline-block`}>
                <FontAwesomeIcon className="animated zoomIn fa-solid" icon={faCamera}/>
            </div>
        </>
    )
}

export default CameraTag;
